import { render, staticRenderFns } from "./MyOrdersServicesProvider.vue?vue&type=template&id=072da2a8&scoped=true"
import script from "./MyOrdersServicesProvider.vue?vue&type=script&lang=js"
export * from "./MyOrdersServicesProvider.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersServicesProvider.vue?vue&type=style&index=0&id=072da2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072da2a8",
  null
  
)

export default component.exports